import { Box } from '@mui/material';
import { MarketSentimentDownArrow } from 'component/BuyersMarketplace/Marketplaceicons';
import React, { useEffect, useRef } from 'react';

const InsightMarketSentiment = ({ value = 70, duration = 2000 }) => {
  const containerRef = useRef(null);
  const arrowRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    const arrow = arrowRef.current;
    if (!container || !arrow) return;

    let animationFrameId = null;

    const animateArrow = () => {
      const target = Math.max(0, Math.min(100, value));
      const startTime = performance.now();

      const animate = (time) => {
        const elapsed = time - startTime;
        let progress = elapsed / duration;

        if (progress > 1) progress = 1;

        // Smooth easing
        const ease = 1 - Math.pow(1 - progress, 3);

        const startValue = 10;
        const currentPos = startValue + (target - startValue) * ease;
        arrow.style.left = `${currentPos}%`;

        if (progress < 1) {
          animationFrameId = requestAnimationFrame(animate);
        }
      };

      arrow.style.left = '0%';

      setTimeout(() => {
        requestAnimationFrame(animate);
      }, 100);
    };

    // Intersection Observer
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateArrow();
          }
        });
      },
      {
        threshold: 0.6,
        rootMargin: '0px 0px -30px 0px',
      }
    );

    observer.observe(container);

    return () => {
      observer.disconnect();
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
    };
  }, [value, duration]);

  return (
    <Box
      ref={containerRef}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        // borderRadius: '8px',
        padding: '22px 9px',
        width: 'fit-content',
      }}
    >
      <Box sx={{ position: 'relative', width: 280, height: 14 }}>
        {/* Gradient Bar */}
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
            height: '22px',
            borderRadius: '9999px',
            background:
              'linear-gradient(to right, #CB5B66 33%, #F59E0B 33%, #F59E0B 66%, #22C55E 66%)',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          }}
        />

        {/* Arrow */}
        <Box
          ref={arrowRef}
          style={{
            position: 'absolute',
            top: '-18px',
            left: '0%',
            transform: 'translateX(-50%)',
            fontSize: '20px',
            color: '#1F2937',
            zIndex: 2,
          }}
        >
          <MarketSentimentDownArrow />
        </Box>
      </Box>
    </Box>
  );
};

export default InsightMarketSentiment;
